import { DetailedInsight, InsightsEpisode } from '@toggle/toggle';
import { format } from 'date-fns';
import { TFunction } from 'i18next';

import { InsightWidgetData } from '~/stores/use-chat/use-chat.types';

export const getInsightTotalTradingDays = (insight: DetailedInsight) => {
  return insight.episodes.reduce((acc, ep) => acc + ep.events.length, 0);
};

export const getInsightEpisodeDates = (episodes: InsightsEpisode[]) =>
  episodes.map(episode => format(new Date(episode.start_date), 'yyyy-MM-dd'));

export const filterPredictions = (
  data: InsightWidgetData,
  indexMax: number
) => {
  return {
    ...data,
    predictions: data.predictions.filter((_, i) => i <= indexMax),
  };
};

export const getInsightCondition = (insight: DetailedInsight, t: TFunction) => {
  const conditions = insight.conditions.map(
    condition => condition.condition_text
  );
  const andLabel = t('scenarioCommander:domino.and');
  return conditions.join(`${andLabel}\n`);
};
